import { saveScoreOffline, getPendingScores, removeScore } from "../db/scoresDB";
import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

  
// Fonction pour envoyer un score à l'API pour les villages
export async function sendScore(score) {
  try {
      const response = await fetch(base + "scores/manage", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(score),
      });

      if (!response.ok || response.message) throw new Error("Échec de l'envoi");

      return true; // Score envoyé avec succès
  } catch (error) {
      console.warn("Pas de connexion, sauvegarde locale...");
      await saveScoreOffline(score);
      return false;
  }
}

// Fonction pour envoyer un score à l'API pour les jeux independants
export async function sendGameScore(score) {
  try {
      const response = await fetch(base + "scores-inde/manage", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(score),
      });

      if (!response.ok || response.message) throw new Error("Échec de l'envoi");

      return true; // Score envoyé avec succès
  } catch (error) {
      console.warn("Pas de connexion, sauvegarde locale...");
      await saveScoreOffline(score);
      return false;
  }
}

export async function getAllScoresByUser(u) {
  try {
    const response = await fetch(base + 'scores/u/' + u);
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllScoresByUser', error);
    throw error;
  }
}